import { __decorate, __metadata } from "tslib";
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
export var Lead;
(function (Lead) {
    Lead[Lead["Invalid"] = 0] = "Invalid";
    Lead[Lead["Valid"] = 1] = "Valid";
})(Lead || (Lead = {}));
export const LeadValidityMap = new Map([
    [Lead.Invalid, 'Global.Text.Invalid'],
    [Lead.Valid, 'Global.Text.Valid'],
]);
let LeadValidityService = class LeadValidityService {
    constructor(_translate) {
        this._translate = _translate;
        this._data = LeadValidityMap;
    }
    list() {
        return this._data;
    }
    get(key) {
        const k = this._data.get(key);
        return k ? this._translate.instant(k) : k;
    }
};
LeadValidityService.ctorParameters = () => [
    { type: TranslateService }
];
LeadValidityService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [TranslateService])
], LeadValidityService);
export { LeadValidityService };
